<template>
    <common-modal v-if="isOpen" width="medium" @close="closeModal">
        <common-content-wrapper width="small">
            <common-content-spacer height="large">
                <common-page-header
                    :heading="modalHeading"
                    :content="
                        $t('modals.practice_privileges_modal.specify_privileges', {
                            name: userFullName,
                            practiceName: user.practice.name,
                        })
                    "
                    :isCenter="true"
                    contentSpacing="medium"
                ></common-page-header>

                <common-content-spacer height="super-huge">
                    <div class="practice-privileges__privilege">
                        <switch-input
                            v-if="!userIsPhysicianOrAdmin"
                            :label="$t('modals.practice_privileges_modal.availability_privilege')"
                            :isLabelOnLeft="true"
                            :value="modifyPhysiciansAvailabilityPrivilege"
                            spacing="space-between"
                            @change="modifyPhysiciansAvailabilityPrivilegeChanged"
                        ></switch-input>
                        <switch-input
                            :label="$t('modals.practice_privileges_modal.practice_membership_privilege')"
                            :isLabelOnLeft="true"
                            :value="managePracticeMembershipPrivilege"
                            spacing="space-between"
                            @change="managePracticeMembershipPrivilegeChanged"
                        ></switch-input>
                    </div>

                    <common-buttons>
                        <common-button
                            :label="$t('common.microcopy.cancel')"
                            type="secondary"
                            size="large-long"
                            @click="closeModal"
                        ></common-button>
                        <common-button
                            :label="$t('common.microcopy.confirm')"
                            type="primary"
                            size="large-long"
                            @click="confirm"
                        ></common-button>
                    </common-buttons>
                </common-content-spacer>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    import SwitchInput from '../../form-inputs/SwitchInput.vue'
    import UserRolesEnum from '../../../enums/UserRolesEnum'

    export default {
        components: { SwitchInput },

        props: {
            isOpen: { type: Boolean, required: true },
            isModifyingPrivileges: { type: Boolean, default: false },
            user: { type: Object, required: true },
        },

        data() {
            return {
                managePracticeMembershipPrivilege: false,
                modifyPhysiciansAvailabilityPrivilege: false,
            }
        },

        computed: {
            modalHeading() {
                return this.isModifyingPrivileges
                    ? this.$t('modals.practice_privileges_modal.user_membership', { name: this.userFullName })
                    : this.$t('modals.practice_privileges_modal.confirm_membership', { name: this.userFullName })
            },

            userFullName() {
                return `${this.user.firstName} ${this.user.lastName}`
            },

            userIsPhysicianOrAdmin() {
                return [
                    UserRolesEnum.PHYSICIAN.ID,
                    UserRolesEnum.NURSE_PRACTITIONER.ID,
                    UserRolesEnum.OFFICE_MANAGER.ID,
                ].includes(this.user.userRole?.id)
            },
        },

        methods: {
            confirm() {
                const eventName = this.isModifyingPrivileges ? 'modify-privileges' : 'membership-approved'
                this.emitEvent({
                    name: eventName,
                    payload: {
                        canManagePractice: this.managePracticeMembershipPrivilege,
                        canModifyPracticeMemberAvailability: this.modifyPhysiciansAvailabilityPrivilege,
                    },
                })
            },

            modifyPhysiciansAvailabilityPrivilegeChanged(event) {
                this.modifyPhysiciansAvailabilityPrivilege = event
            },

            managePracticeMembershipPrivilegeChanged(event) {
                this.managePracticeMembershipPrivilege = event
            },

            prefillPrivileges() {
                this.modifyPhysiciansAvailabilityPrivilege =
                    this.user.canModifyPracticeMemberAvailability || this.userIsPhysicianOrAdmin
                this.managePracticeMembershipPrivilege = this.user.isMasterUser
            },

            closeModal() {
                this.prefillPrivileges()
                this.emitEvent({ name: 'close' })
            },
        },

        mounted() {
            this.prefillPrivileges()
        },
    }
</script>

<style lang="scss" scoped>
    .practice-privileges__privilege {
        color: #333333;
        & > div {
            padding-top: 15px;
            padding-bottom: 10px;
            border-bottom: 1px solid #d8d8d8;
        }
    }
</style>
